module.exports = __webpack_public_path__ + "img/emoji-neutral.5496a0f0.svg";